export default __webpack_public_path__ + "static/hundredfinance-41c81994ed11615de4669781ea7974c6.jpg";